export default "__VITE_ASSET__D0yQjHX9__"